import IsNullOrUndefined from "../utils/ObjectUtils";
import {CategoryType} from "../model/constants";

export const RulesUtility = {

    findValidFeatureForCategory: (rules, categories, changedCategory) => {
        const validFeature = changedCategory.features.find(changedFeature => {
            // Find all applicable rules for this feature
            const applicableRules = rules.filter(rule => rule.linkedFeatures.includes(changedFeature.id));

            if (applicableRules.length === 0) {
                return true; // No rules apply, so this feature is always valid
            }

            // Check if this feature can satisfy at least one applicable rule
            return applicableRules.some(rule => {
                const rulePairsByCategory = rule.linkedFeatures.reduce((acc, featureId) => {
                    const category = categories.find(cat => cat.features.some(f => f.id === featureId));
                    if (category) {
                        if (!acc[category.id]) {
                            acc[category.id] = new Set();
                        }
                        acc[category.id].add(featureId);
                    }
                    return acc;
                }, {});

                // Validate rule: each category in the rule must satisfy one of the linked features
                return Object.keys(rulePairsByCategory).every(categoryId => {
                    if (parseInt(categoryId) === changedCategory.id) return true; // Skip the changed category

                    const selectedFeature = categories.find(cat => cat.id === parseInt(categoryId))?.selected_feature;
                    if (!selectedFeature) return true; // If no feature is selected, it doesn't block

                    // The selected feature must match one of the rule's linked features for that category
                    return rulePairsByCategory[categoryId].has(selectedFeature);
                });
            });
        });

        // Set the valid feature if found, otherwise clear selection
        if (validFeature) {
            changedCategory.selected_feature = validFeature.id;
        } else {
            changedCategory.selected_feature = 0; // Clear selection if no valid feature is found
        }
    },

    validateAllRules: (rules, categories) => {
        categories.forEach(category => {
            if (category.selected_feature) {
                // Check if the selected feature is valid according to the rules
                const isValid = rules.some(rule => {
                    if (!rule.linkedFeatures.includes(category.selected_feature)) {
                        return false; // The rule does not include the selected feature
                    }

                    // Validate the rule for all linked features
                    return rule.linkedFeatures.every(linkedFeature => {
                        const linkedCategory = categories.find(cat =>
                            cat.features.some(f => f.id === linkedFeature)
                        );

                        if (!linkedCategory) return true; // If the linked category doesn't exist, skip

                        if (linkedCategory.id === category.id) return true; // Skip the current category

                        // If the linked category has a selected feature, it must match the rule
                        return linkedCategory.selected_feature === 0 ||
                            linkedCategory.selected_feature === linkedFeature;
                    });
                });

                // If the selected feature is not valid, find a valid one
                if (!isValid) {
                    RulesUtility.findValidFeatureForCategory(rules, categories, category);
                }
            }
        });
    },

    validateRulesForSelectedFeature: (rules, categories, addedCategoriesFromRule, removedCategoriesFromRule, changedCategory, changedFeature) => {
        let isValid = true;
        const modifiedCategories = new Set(); // Track modified categories

        // Find all applicable rules that include the changed feature
        const applicableRules = rules.filter(rule => rule.linkedFeatures.includes(changedFeature));

        // If there are no applicable rules, it is automatically valid
        if (applicableRules.length === 0) return true;

        // Check each applicable rule
        applicableRules.forEach(rule => {
            rule.linkedFeatures.forEach(linkedFeature => {
                // Find the category for the linked feature
                const category = categories.find(cat =>
                    cat.features.some(feature => feature.id === linkedFeature)
                );

                if (!category) return; // No matching category

                // If this is the changed category, skip it
                if (category.id === changedCategory) return;

                // If this category has already been modified, skip it
                if (modifiedCategories.has(category.id)) return;

                // Check if the category has a conflicting selected feature
                if (category.selected_feature !== 0 && category.selected_feature !== linkedFeature) {
                    removedCategoriesFromRule.push({ ...category });
                    addedCategoriesFromRule.push({
                        ...category,
                        selected_feature: linkedFeature
                    });
                    modifiedCategories.add(category.id); // Mark this category as modified
                    isValid = false;
                }
            });
        });

        return isValid;
    }







    /* findValidFeatureForCategory: (rules, categories, changedCategory) => {
        let foundCompatible = false;
        changedCategory.features.forEach(changedFeature => {
            let isValid = true;
            rules.forEach(rule => {
                if (rule.linkedFeatures.indexOf(changedFeature.id) !== -1)
                {
                    rule.linkedFeatures.forEach(linkedFeature => {
                        categories.forEach(category => {
                            const foundFeature = category.features.find(feature => feature.id === linkedFeature);
                            if (!IsNullOrUndefined(foundFeature) && category.selected_feature !== 0) {
                                if (category.id !== changedCategory.id && category.selected_feature !== linkedFeature) {
                                    isValid = false;
                                }
                            }
                        });
                    });
                }
            });

            if (isValid && !foundCompatible) {
                changedCategory.selected_feature = changedFeature.id;
                foundCompatible = true;

            }
        });
    }, */
};
